import { render, staticRenderFns } from "./BCOptionalFeaturesKeyFunction.vue?vue&type=template&id=6d8f8077"
import script from "./BCOptionalFeaturesKeyFunction.vue?vue&type=script&lang=js"
export * from "./BCOptionalFeaturesKeyFunction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports